import type { Asserts } from 'yup';

import { contractSchema as kradContractSchema } from '@/features/Sparten/krad/schema/contractSchema';
import { genericStoreFactory } from '@/utils/genericStoreFactory/genericStoreFactory';

export const contractSchema = kradContractSchema;

export type ContractStore = Asserts<typeof contractSchema>;

export const useKradContractStore = genericStoreFactory(
  () => contractSchema.getDefault() as ContractStore,
  'KradContractStore',
);
